import React from 'react';
import cl from './Pays.module.css'
import Vrasrabotke from '../../components/UI/Vrasrabotke/Vrasrabotke';


const PaysAccount = () => {
    return (
        <div>
            <Vrasrabotke />
        </div>
    )
};

export default PaysAccount;
